import { ReactNode } from 'react';

import { isDevBuild } from '../functions';

interface Props {
  children?: ReactNode;
}

export const DevOnly = ({ children }: Props) =>
  isDevBuild() ? <>{children}</> : null;
